// extracted by mini-css-extract-plugin
module.exports = {"attribute":"AttributesList_attribute__1SayQ"};